// import { TeamsList } from "components/Teams";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { TeamsList } from "../../components/TeamsList";


export interface ITeamsListPage {}

export const TeamsListPage: FC<ITeamsListPage> = (
  props: ITeamsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Teams List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Teams", navigateTo: "/company/teams/list" },
      ]}
      mainContents={<TeamsList />}
    />
  );
};
